import {
  AlertMessage,
  AlertMessageBadge,
  AlertMessageBadgeLabel,
  AlertMessageBody,
  AlertMessageCopy,
  AlertMessageText,
  AlertMessageTextVariant,
  AlertMessageTitle,
} from '@vs-shop/commerce-ui/alertMessage';
import { getLucideIconFromKebabString } from '../../../../../shared/utils/lucideIcons';
import { createElement } from 'react';
import { ChevronRight } from 'lucide-react';

import Link from '@vs-shop/image-link/Link';

import type { Announcement } from '@vs-shop/engine/service/announcements/Announcement';

type Props = {
  readonly message: Announcement;
};

export function AlertMessageBase({ message }: Props) {
  const icon = message.icon ?? null;
  const link = message.link ?? null;
  const buttonText = message.buttonText ?? null;

  const IconComponent = icon !== null ? getLucideIconFromKebabString(icon) : null;

  const content = (
    <>
      {IconComponent !== null ? createElement(IconComponent) : null}

      <AlertMessageBody>
        <AlertMessageText
          variant={
            link !== null ? AlertMessageTextVariant.UNDERLINED : AlertMessageTextVariant.PLAIN
          }
        >
          {message.title ? (
            // space instead of margin to keep the underline flow
            <AlertMessageTitle>{message.title}: </AlertMessageTitle>
          ) : null}
          <AlertMessageCopy>{message.message}</AlertMessageCopy>
        </AlertMessageText>

        {buttonText !== null ? (
          <AlertMessageBadge>
            <AlertMessageBadgeLabel>{buttonText}</AlertMessageBadgeLabel>
            <ChevronRight />
          </AlertMessageBadge>
        ) : null}
      </AlertMessageBody>
    </>
  );

  return link !== null ? (
    <AlertMessage render={<Link href={link} />}>{content}</AlertMessage>
  ) : (
    <AlertMessage>{content}</AlertMessage>
  );
}
